import { MediaItem } from '@/types/greenroom/media.types';
import { Get } from '../helpers';

const GetMedia = (meetingId: number): Promise<MediaItem[] | null> => {
  const url = `${import.meta.env.VITE_GREENROOM_API}/v2/greenroom/media/${meetingId}`;

  return Get({
    path: url,
    includeBlToken: true,
    headers: {
      'bl-global-resource': 'false',
    },
    // Note: do not use cache, we need to make sure we always fetch latest data so we don't
    // accidentally send stale updates to greeenroom shot feeds
  });
};

export default GetMedia;
